import { IApiLineupPlayer } from '@trackman/baseball-shared-components';
import type { AxiosInstance } from 'axios';
import { injectable } from 'inversify';

@injectable()
export class PlayerService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  savePlayerAtBat = (player: IApiLineupPlayer) => {
    this.axiosInstance.post('api/player/playerAtBat', player);
  };
}
